import EmapUploadfile from '../../emap-uploadfile/index.vue';
import meta from '../metas/emap-upload';
export default {
  meta,
  components: {
    EmapUploadfile
  },
  methods: {
    updateToken(val) {
      this.$emit('input', val);
    },

    saveEmapUpload() {
      return this.$refs.emapupload.saveAttachment();
    }

  }
};